import i18n from 'helpers/i18n';
import messages from './messages';
import useAsync from 'hooks/useAsync';
import { Dialog, Button } from '@teachstonellc/component-library';
import { submitAssessment } from 'actions/envScales/assessments';
import { useState } from 'react';
import { ServerError } from 'types/api/ServerError';

interface SubmitModalProps {
  /** Assessment ID. */
  assessmentId: number;

  /** Whether the modal is open. */
  open: boolean;

  /** Callback fired when the assessment is successfully submitted. */
  onSuccess: () => void;

  /** Callback fired when there are errors on submit. */
  onErrors?: (error: ServerError) => JSX.Element[];

  /** Callback fired when the modal requests to be closed. */
  onClose: () => void;
}

function SubmitModal({
  assessmentId,
  open,
  onSuccess,
  onErrors,
  onClose
}: SubmitModalProps) {
  const [errors, setErrors] = useState<JSX.Element[] | null>();
  const { run, isLoading } = useAsync();

  function handleSubmit() {
    run(submitAssessment(assessmentId), {
      onSuccess,
      onError: error => setErrors(onErrors!(error))
    });
  }

  function handleCancel() {
    setErrors([]);
    onClose();
  }

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && handleCancel()}
      title={i18n.ft(messages.header)}
      description={
        <>
          {i18n.ft(messages.description)}
          {errors && errors.map((error, key) => <div key={key}>{error}</div>)}
        </>
      }
      closeButton={
        <Button variant="secondary" disabled={isLoading}>
          {i18n.ft(messages.cancel)}
        </Button>
      }
      actionButton={
        <Button
          variant="primary"
          loading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}
        >
          {i18n.ft(messages.submit)}
        </Button>
      }
    />
  );
}

export default SubmitModal;
